module.exports = __webpack_public_path__ + "img/people.1cb2624d.png";